// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"e1b52e06","59":"526c52ed","190":"cb44d02a","787":"063030b7"}[chunkId] + ".chunk.js";
};